import { staffClient } from 'clients/staff';

export interface Category {
    id: number;
    name: string;
    boardId: number;
    order: number;
    created_at: string;
    updated_at: string;
}

export interface CreateCategoryDto {
    name: string;
    boardId: number;
    order?: number;
}

export interface UpdateCategoryDto {
    name?: string;
    boardId?: number;
    order?: number;
}

export const categoryApi = {
    // 모든 카테고리 조회
    getAll: async (): Promise<Category[]> => {
        try {
            const response = await staffClient.get('/category');
            return response.data?.data || response.data || [];
        } catch (error) {
            console.error('[categoryApi] getAll error:', error);
            throw error;
        }
    },

    // 특정 카테고리 조회
    getById: async (id: number): Promise<Category> => {
        try {
            const response = await staffClient.get(`/category/${id}`);
            return response.data;
        } catch (error) {
            console.error('[categoryApi] getById error:', error);
            throw error;
        }
    },

    // 게시판별 카테고리 조회
    getByBoardId: async (boardId: number): Promise<Category[]> => {
        try {
            const response = await staffClient.get('/category', {
                params: { boardId }
            });
            const categories = response.data?.data || response.data || [];
            return categories.filter((cat: Category) => cat.boardId === boardId);
        } catch (error) {
            console.error('[categoryApi] getByBoardId error:', error);
            throw error;
        }
    },

    // 카테고리 생성
    create: async (data: CreateCategoryDto): Promise<Category> => {
        try {
            const response = await staffClient.post('/category', data);
            return response.data;
        } catch (error) {
            console.error('[categoryApi] create error:', error);
            throw error;
        }
    },

    // 카테고리 수정
    update: async (id: number, data: UpdateCategoryDto): Promise<Category> => {
        try {
            const response = await staffClient.patch(`/category/${id}`, data);
            return response.data;
        } catch (error) {
            console.error('[categoryApi] update error:', error);
            throw error;
        }
    },

    // 카테고리 삭제
    delete: async (id: number): Promise<void> => {
        try {
            await staffClient.delete(`/category/${id}`);
        } catch (error) {
            console.error('[categoryApi] delete error:', error);
            throw error;
        }
    }
};